import { ReactNode, createContext, useContext } from 'react';

type IProps = {
  children: ReactNode;
};

type ContextProps = {
  demo: boolean;
};

const Ctx = createContext<ContextProps>({
  demo: true,
});

export const FlagsProvider = ({ children }: IProps) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const demo = !!JSON.parse((window as any)._env_?.REACT_APP_FLAG_DEMO || 0);

  return (
    <Ctx.Provider
      value={{
        demo,
      }}
    >
      {children}
    </Ctx.Provider>
  );
};

export const useFlags = () => useContext(Ctx);
